import { InvoiceStatus } from "@/graphql/codegen/graphql"

export enum AccountsPayableTransactionType {
  InvoiceApproved = "INVOICE_APPROVED",
  InvoicePaid = "INVOICE_PAID",
  InvoiceReversed = "INVOICE_REVERSED",
  InvoicePaymentVoided = "INVOICE_PAYMENT_VOIDED",
}

// AK-6189 AC4/AC5: a ledger row stores the raw InvoiceStatus that triggered it, but an approval
// reversal can land on any of three statuses and is one transaction type to the user — so the four
// types AC4 lists are groups of statuses, not statuses. Declaration order drives the filter drawer.
export const ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_INVOICE_STATUSES: Record<
  AccountsPayableTransactionType,
  InvoiceStatus[]
> = {
  [AccountsPayableTransactionType.InvoiceApproved]: [InvoiceStatus.Approved],
  [AccountsPayableTransactionType.InvoicePaid]: [InvoiceStatus.Paid],
  [AccountsPayableTransactionType.InvoiceReversed]: [
    InvoiceStatus.PendingApproval,
    InvoiceStatus.Cancelled,
    InvoiceStatus.NotApproved,
  ],
  [AccountsPayableTransactionType.InvoicePaymentVoided]: [InvoiceStatus.Voided],
}

export const INVOICE_STATUS_TO_ACCOUNTS_PAYABLE_TRANSACTION_TYPE = Object.entries(
  ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_INVOICE_STATUSES
).reduce(
  (acc, [type, statuses]) => {
    statuses.forEach((status) => {
      acc[status] = type as AccountsPayableTransactionType
    })

    return acc
  },
  {} as Record<InvoiceStatus, AccountsPayableTransactionType>
)

export const ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_LABEL: Record<AccountsPayableTransactionType, string> = {
  [AccountsPayableTransactionType.InvoiceApproved]: "Invoice Approved",
  [AccountsPayableTransactionType.InvoicePaid]: "Invoice Paid",
  [AccountsPayableTransactionType.InvoiceReversed]: "Invoice Reversed",
  [AccountsPayableTransactionType.InvoicePaymentVoided]: "Invoice Payment Voided",
} as const

export const ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_CLASS_NAME: Record<AccountsPayableTransactionType, string> = {
  [AccountsPayableTransactionType.InvoiceApproved]: "bg-primary-200 text-gray-900",
  [AccountsPayableTransactionType.InvoicePaid]: "bg-tertiary-green-100 text-gray-900",
  [AccountsPayableTransactionType.InvoiceReversed]: "bg-tertiary-orange-300 text-gray-900",
  [AccountsPayableTransactionType.InvoicePaymentVoided]: "bg-gray-300 text-gray-900",
} as const

export const ACCOUNTS_PAYABLE_FILTERABLE_TRANSACTION_TYPES: AccountsPayableTransactionType[] =
  Object.values(AccountsPayableTransactionType)
